import technologies from "../data/technologies";

function TechMarquee() {
  const items = technologies;
  return (
    <div className="marquee" aria-label="Technologies we work with">
      <div className="marquee__track">
        {items.map((tech, index) => (
          <span className="marquee__item" key={`${tech.name}-${index}`}>
            <i className={`${tech.devicon} marquee__icon`} />
            {tech.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default TechMarquee;
